// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2lRhy","text":"SelectPayment_text__S6gHY","title":"SelectPayment_title__2llOR","btn":"SelectPayment_btn__1G7Qw"};